import {ComposedChart} from '@crema/modules/thirdParty';
export default ComposedChart;
